// The following code was extracted from productFilterTile as it is, in order to be called from other places as well;
// TODO: in future, rewrite this routine with a more readable and simpler code and remove this comment.
export const filterProducts = (filtersList, products, isOrpFilter, fieldToCompare) => {
    const submittedFilterItems = [];
    filtersList.map((list) => {
        submittedFilterItems[list.filterGroupName] = [];
        list.filters.forEach(
            (filter) =>
                filter.checked &&
                submittedFilterItems[list.filterGroupName].push(
                    ...filter.filterItems
                )
        );
        return true;
    });
    let finalFilteredItems = [];
    Object.keys(submittedFilterItems)?.length > 0 &&
        Object.keys(submittedFilterItems).map(
            (submittedData) =>
                submittedFilterItems[submittedData]?.length === 0 &&
                delete submittedFilterItems[submittedData]
        );
    Object.keys(submittedFilterItems).map((submittedData, index) => {
        if (submittedFilterItems[submittedData]?.length > 0) {
            if (index === 0) {
                finalFilteredItems = [...submittedFilterItems[submittedData]];
            } else {
                finalFilteredItems = finalFilteredItems.filter((value) =>
                    submittedFilterItems[submittedData].includes(value)
                );
            }
        }
        return true;
    });
    if (finalFilteredItems?.length > 0) {
        const filterArray = [];
        products?.map((prodObj) =>
            finalFilteredItems?.map((item) => {
                if (
                    (isOrpFilter && prodObj.isOrp) ||
                    (!isOrpFilter && !prodObj.isOrp)
                ) {
                    if (prodObj[fieldToCompare || 'productOsr']?.startsWith(item.trim())) {
                        filterArray.push(prodObj);
                    }
                }
                return true;
            })
        );
        const uniqueFilterArray = [...new Set(filterArray.map((item) => item))];
        uniqueFilterArray.map((item, i, uniqueFilters) => {
            if (
                (item.prodRefCode === 'JLRY_BOX' ||
                    item.prodRefCode === 'JLRY_BOX_CND') &&
                i != uniqueFilters.length - 1
            ) {
                uniqueFilters.splice(i, 1);
                uniqueFilters.push(item);
            }
        });
        return uniqueFilterArray
    } else {
        return (Object.keys(submittedFilterItems)?.length === 0) ? products : []
    }
}